export const COMPANY_BASIC_FREE_CAMPAIGN_END_LABEL = '2026.12.31';

// Inclusive end date in UTC: 2026-12-31 23:59:59.
const COMPANY_BASIC_FREE_CAMPAIGN_END_UTC_MS = Date.UTC(2026, 11, 31, 23, 59, 59, 999);

export const isCompanyBasicFreeCampaignActive = () => Date.now() <= COMPANY_BASIC_FREE_CAMPAIGN_END_UTC_MS;

